import {
  GET_ACTIVE_POST,
  GET_COMPLETD_MINE_POSTS,
  GET_COMPLETD_MINE_UMB_POSTS,
  GET_DEACTIVE_POST,
  GET_FILTERD_POSTS,
  GET_FILTER_POSTS,
  GET_MINE_POSTS,
  GET_PBP_BY_ID,
  GET_POSTS,
  GET_POSTS_BY_ID,
  GET_POSTS_COUNT,
  GET_PROPOSED_POST,
  GET_SIMILAR_POSTS,
} from "../constants";

export const posts = (
  state = {
    postlist: [],
    getpostlist: [],
    getsimilarpostlist: [],
    postlistmine: [],
    completedpostlistmine: [],
    completedumbrellapostlistmine: [],
    postbyid: {},
    pbpbyid: {},
    getfilterdpost: [],
    getproposedpostlist: [],
    getactivepostlist: [],
    getdeactivepostlist: [],
    postcounts: {},
  },
  action,
) => {
  switch (action.type) {
    case GET_POSTS:
      return { ...state, postlist: action.postlist };
    case GET_SIMILAR_POSTS:
      return { ...state, getsimilarpostlist: action.getsimilarpostlist };
    case GET_FILTER_POSTS:
      return { ...state, getpostlist: action.getpostlist };
    case GET_POSTS_BY_ID:
      return { ...state, postbyid: action.postbyid };
    case GET_PBP_BY_ID:
      return { ...state, pbpbyid: action.pbpbyid };
    case GET_MINE_POSTS:
      return { ...state, postlistmine: action.postlistmine };
    case GET_FILTERD_POSTS:
      return { ...state, getfilterdpost: action.getfilterdpost };
    case GET_PROPOSED_POST:
      return { ...state, getproposedpostlist: action.getproposedpostlist };
    case GET_ACTIVE_POST:
      return { ...state, getactivepostlist: action.getactivepostlist };
    case GET_DEACTIVE_POST:
      return { ...state, getdeactivepostlist: action.getdeactivepostlist };
    case GET_COMPLETD_MINE_POSTS:
      return { ...state, completedpostlistmine: action.completedpostlistmine };
    case GET_COMPLETD_MINE_UMB_POSTS:
      return {
        ...state,
        completedumbrellapostlistmine: action.completedumbrellapostlistmine,
      };
    case GET_POSTS_COUNT:
      return { ...state, postcounts: action.postcounts };
    default:
      return state;
  }
};
